import React from 'react'
import { cn } from '@/utilities/ui'

type HeadingTag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'

type Props = {
  text: string
  as?: HeadingTag
  className?: string
  /** Font size at each breakpoint, e.g. ['text-[32px]', 'md:text-[48px]', 'lg:text-[60px]'] */
  sizes?: string[]
  /** Line height at each breakpoint, e.g. ['leading-[38px]', 'lg:leading-[68px]'] */
  leadings?: string[]
  style?: React.CSSProperties
}

function parseLines(text: string): string[] {
  return text
    .replace(/<br\s*\/?>/gi, '\n')
    .split('\n')
    .map((l) => l.trim())
}

export const HeadingWithBreaks: React.FC<Props> = ({
  text,
  as: Tag = 'h2',
  className,
  sizes = [],
  leadings = [],
  style,
}) => {
  const lines = parseLines(text)

  return (
    <Tag className={cn(...sizes, ...leadings, className)} style={style}>
      {lines.map((line, i) => (
        <React.Fragment key={i}>
          {line}
          {i < lines.length - 1 ? <br /> : null}
        </React.Fragment>
      ))}
    </Tag>
  )
}
